import { cn } from '../../../lib/utils'

const icons = {
  pdf: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <text x="6" y="18" fontSize="6" fontWeight="bold" fill="currentColor" stroke="none">PDF</text>
    </svg>
  ),
  word: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <text x="6" y="18" fontSize="5.5" fontWeight="bold" fill="currentColor" stroke="none">DOC</text>
    </svg>
  ),
  excel: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <text x="6.5" y="18" fontSize="5.5" fontWeight="bold" fill="currentColor" stroke="none">XLS</text>
    </svg>
  ),
  ppt: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <text x="6.5" y="18" fontSize="5.5" fontWeight="bold" fill="currentColor" stroke="none">PPT</text>
    </svg>
  ),
  ebook: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
    </svg>
  ),
  image: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="3" y="3" width="18" height="18" rx="2"/>
      <circle cx="8.5" cy="8.5" r="1.5"/>
      <polyline points="21 15 16 10 5 21"/>
    </svg>
  ),
  text: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <line x1="16" y1="13" x2="8" y2="13"/>
      <line x1="16" y1="17" x2="8" y2="17"/>
    </svg>
  ),
  generic: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
    </svg>
  ),
}

const colorMap = {
  pdf:     'bg-red-100 text-red-600',
  word:    'bg-blue-100 text-blue-600',
  excel:   'bg-green-100 text-green-600',
  ppt:     'bg-orange-100 text-orange-600',
  ebook:   'bg-purple-100 text-purple-600',
  image:   'bg-sky-100 text-sky-600',
  text:    'bg-gray-100 text-gray-500',
  generic: 'bg-gray-100 text-gray-400',
}

export function getFileType(mimeType = '') {
  if (mimeType === 'application/pdf') return 'pdf'
  if (mimeType.includes('word') || mimeType === 'application/msword') return 'word'
  if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) return 'excel'
  if (mimeType.includes('powerpoint') || mimeType.includes('presentation')) return 'ppt'
  if (mimeType.includes('epub') || mimeType.includes('mobipocket')) return 'ebook'
  if (mimeType.startsWith('image/')) return 'image'
  if (mimeType.startsWith('text/') || mimeType === 'application/rtf') return 'text'
  return 'generic'
}

export const FileTypeIcon = ({ mimeType, size = 40 }) => {
  const type  = getFileType(mimeType)
  const color = colorMap[type]
  return (
    <div
      className={cn('rounded-xl flex items-center justify-center flex-shrink-0', color)}
      style={{ width: size, height: size }}
    >
      <span style={{ width: size * 0.55, height: size * 0.55 }}>
        {icons[type]}
      </span>
    </div>
  )
}
